var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStackedAreachart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5105 9.64011C21.207 9.45994 20.831 9.4531 20.5212 9.6221L13.8319 13.2706L8.45919 11.4796C8.27874 11.4195 8.08488 11.4121 7.90035 11.4582L2.7574 12.7443C2.31226 12.8556 1.99999 13.2556 2 13.7144L2.00013 19.5C2.00014 20.0523 2.44785 20.5 3.00013 20.5H21C21.2652 20.5 21.5196 20.3946 21.7071 20.2071C21.8946 20.0196 22 19.7652 22 19.5V10.5C22 10.1471 21.814 9.82027 21.5105 9.64011ZM20 12.1845V18.5H4.0001L4.00002 14.4951L8.103 13.4691L13.6124 15.3056C13.8757 15.3934 14.1637 15.3678 14.4075 15.2349L20 12.1845Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8411 3.53704C14.6109 3.47258 14.3652 3.49272 14.1486 3.59382L8.03342 6.44758L3.22736 5.32616C2.93017 5.25681 2.61759 5.32697 2.37854 5.51666C2.13948 5.70635 2.00013 5.99481 2.00013 6.29998L2 13.5L4 13.5L4.0001 7.56019L7.91572 8.47384C8.13388 8.52475 8.36283 8.50092 8.56584 8.40618L14.6586 5.56286L20 7.05846V10.5H22V6.3C22 5.85156 21.7015 5.45795 21.2696 5.33704L14.8411 3.53704Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedAreachart);
export default __webpack_public_path__ + "static/media/stacked_areachart.7bcd6f2a6e77e1695a067a7e14ab2ad8.svg";
export { ForwardRef as ReactComponent };